import classNames from "classnames";
import { Link } from "react-router-dom";
import styles from "./CTA.module.css";

export default function CTA({ text, link="/digikala/seller/information" }) {
  return (
    <Link
      to={link}
      className={classNames(
        "d-block buttonUi btn-success-style text-center py-3 fs-5",
        styles.cta
      )}
    >
      {text}
    </Link>
  );
}
